__turbopack_context__.v({
  "prose": "oLGhcW_prose",
  "prose__divider": "oLGhcW_prose__divider",
  "prose__h1": "oLGhcW_prose__h1",
  "prose__h2": "oLGhcW_prose__h2",
  "prose__h3": "oLGhcW_prose__h3",
  "prose__h4": "oLGhcW_prose__h4",
  "prose__h5": "oLGhcW_prose__h5",
  "prose__p": "oLGhcW_prose__p",
});
